/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-29 14:20:10
 */
import { getCurrentInstance } from 'vue';

// 获取全局变量
const useGlobals = (type) =>{
    const global = getCurrentInstance()?.appContext.config.globalProperties[`$${type}`]
    return global
}

// 获取上一周周一和周日的对应日期
const getLastWeekDate = (n)=> {
    let now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let date = now.getDate()
    let day = now.getDay()
    //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
    n = day !== 0? n + (day - 1) : n + day
    if (day) {
        if (month > 1) { //解决跨年的问题
            month = month
        } else { //解决跨年的问题,月份是从0开始的
            year = year - 1
            month = 12
        }
    }
    now.setDate(now.getDate() - n)
    year = now.getFullYear()
    month = now.getMonth() + 1
    date = now.getDate()
    let s = year + "-" + (month < 10 ? ('0' + month) : month) + "-" + (date < 10 ? ('0' + date) : date)
    return s
}

// 获取当前日期时间
const getCurDate = ()=>{
    let now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let date = now.getDate()
    let s = year + "-" + (month < 10 ? ('0' + month) : month) + "-" + (date < 10 ? ('0' + date) : date)
    return s
}

// 获取当前日期时间戳
const curDateTimestamp = (date)=>{
    let startDate = new Date(`${date} 00:00:00`).getTime().toString().slice(0,10)
    let endDate = new Date(`${date} 23:59:59`).getTime().toString().slice(0,10)

    return {
        startDate,
        endDate
    }
}

// 日期转成时间戳
const dateToTimestamp = (date)=>{
    return new Date(date).getTime().toString().slice(0,10)
}


// 时间戳转成日期
const timestampToDate = (timestamp)=>{
    let date = new Date(timestamp)
    let YY = date.getFullYear()
    let MM = date.getMonth() + 1 < 10? `0${date.getMonth() + 1}` :date.getMonth() + 1
    let DD = date.getDate() < 10? `0${date.getDate()}` : date.getDate()
    let hh = date.getHours() < 10? `0${date.getHours()}` : date.getHours()
    let mm = date.getMinutes() < 10? `0${date.getMinutes()}` : date.getMinutes()
    let ss = date.getSeconds() < 10? `0${date.getSeconds()}` : date.getSeconds()

    return `${YY}-${MM}-${DD} ${hh}:${mm}:${ss}`
}

// 时间戳格式化：自动兼容秒/毫秒
const formatTimestamp = (ts)=>{
    if(ts === undefined || ts === null || ts === '' || ts === 0){
        return '-'
    }
    const num = Number(ts)
    if(Number.isNaN(num)) return ts
    const ms = num > 1e12 ? num : num * 1000
    const d = new Date(ms)
    if(Number.isNaN(d.getTime())) return '-'
    const pad = (n)=> String(n).padStart(2,'0')
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

// 获取字段值--处理空值
const getFieldVal = (val)=>{
    if(val === undefined || val === null || val === '') return '-'    
    else if(val === 0) return 0
    else return val
}

// 下载文件--数据流方式
const exportFile = (data, fileName)=>{
    let blob = new Blob([data])
    let a = document.createElement('a')
    // let filename = res.headers['content-disposition'].split('attachment; ')[1].replace(/^"|"$/g, '')
    a.href = URL.createObjectURL(blob)
    a.download = fileName 
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    URL.revokeObjectURL(a.href)
    document.body.removeChild(a)
}

const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}

export {
    useGlobals,
    getLastWeekDate,
    getCurDate,
    curDateTimestamp,
    dateToTimestamp,
    timestampToDate,
    getFieldVal,
    exportFile,
    formatTimestamp,
    debounce,
}

